// extracted by mini-css-extract-plugin
export default {"title":"Title_title--U3y","secondTitle":"Title_secondTitle--fGT"};